var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", { attrs: { "no-padding": "" } }),
      _vm._v(" "),
      _c(
        "Subheader",
        {
          attrs: { title: "File Schemas", search: "file schemas" },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        },
        [
          _c(
            "v-dialog",
            {
              attrs: { width: "500", persistent: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on }) {
                    return [
                      _c(
                        "v-btn",
                        _vm._g({ attrs: { dark: "", color: "add" } }, on),
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("add"),
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "DatasetMetadataSchemaManage.addTitleMsg"
                                )
                              ) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.addFormDialog,
                callback: function ($$v) {
                  _vm.addFormDialog = $$v
                },
                expression: "addFormDialog",
              },
            },
            [
              _vm._v(" "),
              _c("DatasetMetadataSchemaAddForm", {
                on: {
                  close: function ($event) {
                    _vm.addFormDialog = false
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  loading: _vm.isLoading,
                  headers: _vm.headers,
                  pagination: _vm.pagination,
                  items: _vm.metadataSchemaData,
                  search: _vm.search,
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c("td", [_vm._v(_vm._s(props.item.Name))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  color: "warning",
                                  to: {
                                    name: "schemadetail",
                                    params: { id: `${props.item.Id}` },
                                  },
                                },
                              },
                              [
                                _c("v-icon", { staticClass: "mr-1" }, [
                                  _vm._v("edit"),
                                ]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Button.Edit")) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                            _vm._v("\n            |\n            "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  disabled: props.item.Name == "Generic",
                                  small: "",
                                  color: "error",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.clickRemove(props.item)
                                  },
                                },
                              },
                              [
                                _c("v-icon", { staticClass: "mr-1" }, [
                                  _vm._v("delete"),
                                ]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Button.Delete")) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("AppModal", {
        attrs: { "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(_vm._s(_vm.deleteDialogTitle))]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [_vm._v(_vm._s(_vm.deleteDialogText))]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "delete", dark: "" },
                    on: {
                      click: function ($event) {
                        return _vm.agreeDelete()
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("delete_forever")]),
                    _vm._v(_vm._s(_vm.$t("Button.Remove")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        _vm.dialog = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.dialog,
          callback: function ($$v) {
            _vm.dialog = $$v
          },
          expression: "dialog",
        },
      }),
      _vm._v(" "),
      _c("ErrorDialog", {
        attrs: { data: _vm.errorDialog.data, title: _vm.errorDialog.title },
        model: {
          value: _vm.errorDialog.show,
          callback: function ($$v) {
            _vm.$set(_vm.errorDialog, "show", $$v)
          },
          expression: "errorDialog.show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }